import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { columnAvatarRenderer } from "../../../other/utils/utils.jsx";

export default class EntityFinderBoardUserTab extends EntityFinderTabBase {
  static get $name() {
    return "EntityFinderBoardUserTab";
  }

  static get type() {
    return "entityfinderboardusertab";
  }

  static get configurable() {
    return super.getTabWidget("Board Users", {
        type: WIDGET_KEYS.columnEntityMainName,
        text: "Board User",
        field: "name",
        renderer: ({ record, size }) => (columnAvatarRenderer({
          image: record.profileImageURL,
          name: record.name,
          size: size.configuredHeight,
          archived: record.archived,
        }))
    })
  };

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.userEditor, record, {user: record });
  }

  get storeKey() {
    return STORE_KEYS.boardUserStore;
  }
}
EntityFinderBoardUserTab.initClass();
